import { RememberedAccountErrors } from '@mecontrol/common';
import { setQueryParams } from '@mecontrol/web-boot/lib/src/utilities/url';

declare global {
    interface Window {
        attachEvent?: (type: string, handler: (e: any) => void) => void;
    }
}

let proxiedHostname: string;
let destinationWreply: string;

function handleIdpResponse(e: any): void {
    // remove any trailing '/' from origin before checking. just to keep things clean.
    if ((e.origin || '').replace(/\/$/, '') === proxiedHostname) {
        postResponse(e.data);
    }
}

function postResponse(message: string): void {
    if (window === window.parent) {
        return;
    }

    window.parent.postMessage(message, destinationWreply);
}

/**
 * Given the iFrame control ID, source URL for saved users and allowed hosts, this method will validate the wreply of the source url
 * to match that of the window navication and set its value into the iframe source attribute.
 *
 * @param iFrameId The ID of the iFrame element to set the src value.
 * @param sourceUrl The original saved users endpoint URL to update and set as source after validation.
 * @param allowedHosts A list of hosts that the iframe is allowed to be run in.
 */
export function setFrameSource(iFrameId: string, sourceUrl: string, allowedHosts: string[]): void {
    let frame = document.getElementById(iFrameId) as HTMLIFrameElement;

    // Get current window.location host (with port, if applicable) for validation:
    let host = window.location.hostname.toLowerCase();
    if (window.location.port &&
        !(window.location.port === '443' && window.location.protocol === 'https:') &&
        !(window.location.port === '80' && window.location.protocol === 'http:')
    ) {
        host = `${host}:${window.location.port}`;
    }

    for (let allowedHost of allowedHosts) {
        if (allowedHost.toLowerCase() === host) {
            frame.src = setQueryParams(sourceUrl, { wreply: `https://${host}` });
            return;
        }
    }

    postResponse(JSON.stringify({error: RememberedAccountErrors.InvalidProxiedDomain}));
}

export function attachListeners(hostname: string, wreply: string): void {
    proxiedHostname = hostname;
    destinationWreply = wreply;

    if (window.attachEvent) {
        window.attachEvent('onmessage', handleIdpResponse);
    }
    else {
        window.addEventListener('message', handleIdpResponse, false);
    }
}
